<script setup>
import { ref, watch } from 'vue';

defineOptions({ name: 'DsInput', inheritAttrs: false });

const props = defineProps({
  modelValue: { type: [String, Number], default: undefined },
  defaultValue: { type: [String, Number], default: '' },
  size: { type: String, default: 'md' },
  error: { type: Boolean, default: false },
  type: { type: String, default: 'text' }
});

const emit = defineEmits(['update:modelValue']);

// Funciona controlado (v-model) o no controlado (defaultValue) — los
// mockups del manual usan la forma no controlada.
const local = ref(props.modelValue !== undefined ? props.modelValue : props.defaultValue);
watch(
  () => props.modelValue,
  (v) => { if (v !== undefined) local.value = v; }
);

function onInput(e) {
  local.value = e.target.value;
  emit('update:modelValue', e.target.value);
}

const field = ref(null);
defineExpose({ focus: () => field.value && field.value.focus() });
</script>

<template>
  <div :class="['ds-input', `ds-input--${size}`, { 'is-error': error }]">
    <span
      v-if="$slots.prefix"
      class="ds-input__prefix"
    ><slot name="prefix" /></span>
    <!-- eslint-disable vuejs-accessibility/form-control-has-label —
         primitiva: la etiqueta la aporta el componente Field que la envuelve. -->
    <input
      ref="field"
      :type="type"
      class="ds-input__field"
      :value="local"
      v-bind="$attrs"
      @input="onInput"
    >
    <!-- eslint-enable vuejs-accessibility/form-control-has-label -->
    <span
      v-if="$slots.suffix"
      class="ds-input__suffix"
    ><slot name="suffix" /></span>
  </div>
</template>
